export default {
   meta: {
      code: 'fr',
      name: 'Français',
   },

   auth: {
      
   },

   main: {
      cancel: 'annuler',
      Cancel: 'Annuler',
      delete: 'supprimer',
      Delete: 'Supprimer',
      edit: 'modifier',
      Edit: 'Modifier',
      EditDelete: 'éditer, modifier',
      save: 'enregistrer',
      validate: 'valider',
      Validate: 'Valider',
      password: 'Mot de passe',
      login: 'Se connecter',
      register: 'Créer mon compte',
      back: 'retour',
      knowMore: 'en savoir plus',
      user: 'utilisateur',
      users: 'utilisateurs',
      server: 'serveur',
      Server: 'Serveur',
      Confidentiality: 'Confidentialité',
      mentionLegal: 'Mentions légales',
      follower: 'abonné',
      followers: 'abonnés',
      About: 'À propos',
      Finished: 'Terminé',
      Contacts: 'Contacts',
      Messages: 'Messages',
      New: 'Nouveau',
      Image: 'Image',
      MyProfil: 'Mon profil',
      EventType: 'Type d\'évenement',
      City: 'Ville',
      Mood: 'Ambiance'
   },

   menu: {
      
   },

   home: {
      letsGo: "C'est parti",
      OurChallengeCourseFormulas: "Nos Formules de parcours de défis à"
   },

   register: {
      didNotSignedManifest: 'Vous n\'avez pas encore signé le manifeste',
      readSignedManifest: 'Lire et signer le manifeste',
      manifestSigned: 'Manifeste signé',
      createYourAccount: 'Créez votre compte',

      desc12: 'Pas besoin d\'adresse e-mail',
      desc13: 'seulement un pseudo, et un mot de passe',
      desc14: 'On ne veut pas savoir qui vous êtes',
      desc15: 'On veut seulement savoir ce qu\'on peut faire ensemble',

      alreadyHaveAccount: "Vous avez déjà un compte"
   },

   login: {
      connectToAccount: 'Se connecter',
      name: 'Pseudo, nom d\'utilisateur',
      errorData: 'Désolé, les données de connection sont incorrectes',
      errorUserNotExists: 'Désolé, ce nom d\'utilisateur n\'existe pas sur ce serveur',
      errorUserPageNotExists: 'Désolé, la page associé à votre compte n\'existe pas sur ce serveur',
      errorWrongPwd: 'Désolé, ce compte existe mais le mot de passe est incorrect',
      errorServerUnreachable: 'Désolé, le serveur est injoignable',

   },

   form: {
      required: 'Champs obligatoire',
      characters: 'caractères',
      noSpace: 'Pas d\'espace',
      atLeast8Char: 'Au moins 8 caractères',
      atLeast3Char: 'Au moins 3 caractères, sans espace',
   },

   error: {
      CredentialsAreInvalid : 'Identifiants incorrectes',
      errorData: 'Désolé, les données de connection sont incorrectes',
      errorUserNotExists: 'Désolé, ce nom d\'utilisateur n\'existe pas sur ce serveur',
      errorUserPageNotExists: 'Désolé, la page associé à votre compte n\'existe pas sur ce serveur',
      errorWrongPwd: 'Désolé, ce compte existe mais le mot de passe est incorrect',
      errorServerUnreachable: 'Désolé, le serveur est injoignable',
      
   },


}
